export const defaults = {
  fontFamily: 'DaimlerCS, Calibri, Arial, Verdana, sans-serif',
  fontSize: 1,
  lineHeight: '1.5',
  boxSizing: 'border-box',
  paragraphMargin: '0 auto 15px',
  padding: '0 20px',
  margin: '0 20px',
  borderRadius: '',
  borderSize: '1px',
  borderStyle: 'solid',
  textDecoration: 'none',
  shadowDefault: '3px 3px 5px 0px #bbb',
  shadowLarge: '3px 3px 15px 0px #bbb',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  transition: 'all 0.2s',
  breakpoints: {
    small: 0,
    medium: 640,
    large: 1024,
    xlarge: 1280,
    xxlarge: 1920
  },
  paddings: {
    busselection: 80,
    carousel: 80
  }
};
